import { render } from "./userIndustries.vue?vue&type=template&id=9da4bb7e&ts=true"
import script from "./userIndustries.vue?vue&type=script&lang=ts"
export * from "./userIndustries.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__